import { isDesktop } from "@/js/helpers/mediaQueryHelper";
import { TakeoverDesktop } from "./TakeoverDesktop";
import { TakeoverMobile } from "./TakeoverMobile";

class Takeover {
    static attach() {
        /* eslint-disable-next-line no-unused-vars */
        const takeover = new Takeover();
    }

    constructor() {
        this.takeoverDesktopElement = document.querySelector(".js-takeover--desktop");
        this.takeoverMobileElement = document.querySelector(".js-takeover--mobile");

        if (this.takeoverDesktopElement) {
            this.takeoverDesktop = new TakeoverDesktop(this.takeoverDesktopElement);
        }

        if (this.takeoverMobileElement) {
            this.takeoverMobile = new TakeoverMobile(this.takeoverMobileElement);
        }

        this.bindEvents();
        this.watchScroll();
        this.watchResize();

        window.dispatchEvent(new Event("scroll"));
    }

    dispatchRepositionEvent() {
        if (isDesktop()) {
            if (this.takeoverDesktopElement) {
                this.takeoverDesktopElement.dispatchEvent(
                    new CustomEvent("takeover:reposition", {
                        canBubble: true,
                        cancelable: true,
                        detail: {}
                    })
                );
            }
        } else if (this.takeoverMobileElement) {
            this.takeoverMobileElement.dispatchEvent(
                new CustomEvent("takeover:reposition", {
                    canBubble: true,
                    cancelable: true,
                    detail: {}
                })
            );
        }
    }

    watchScroll() {
        let inProcess = false;

        window.addEventListener(
            "scroll",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.dispatchRepositionEvent();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }

    watchResize() {
        let inProcess = false;

        window.addEventListener(
            "resize",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.dispatchRepositionEvent();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }

    bindEvents() {
        if (this.takeoverDesktopElement) {
            this.takeoverDesktopElement.addEventListener("takeover:reposition", () => {
                this.takeoverDesktop.reposition();
            });
        }

        if (this.takeoverMobileElement) {
            this.takeoverMobileElement.addEventListener("takeover:reposition", () => {
                this.takeoverMobile.reposition();
            });
        }
    }
}

export { Takeover };
